import { ThemeOptions } from "@mui/material";

export const palette: NonNullable<ThemeOptions["palette"]> = {
  primary: {
    main: "#000000",
    light: "#ffffff",
  },
  background: {
    default: "#000000",
    paper: "#ffffff",
  },
  text: {
    primary: "#000000",
    secondary: "#ffffff",
  },
};
